/**
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 *
 * THIS FILE IS MANAGED CENTRALLY BY THE `common-code` REPO.
 * IT COULD BE AUTO-REPLACED AT ANY TIME.
 * DO NOT MAKE CUSTOM CHANGES TO THIS FILE.
 * @see https://gitlab.com/dea-aero/development/common-code
 *
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 */
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

import {createStore as create} from "./util/createStore";


export const useToastStore = create((set) => ({
    popups: [],
    clear: () => set(() => ({popups: []})),
    remove: (obj) => set((state) => ({popups: state.popups.filter(a => a !== obj)})),
    show: (text, severity) => set((state) => {
        const key = `${text}, ${severity}`
        const _new = {text, severity, key}

        _new.timer = setTimeout(() => state.remove(_new), 8000)

        const popups = state.popups.filter(p => p.key !== key);
        popups.push(_new);

        return {popups}
    }),
    freeze: (obj) => set((state) => {
        const popups = state.popups;
        if (obj.timer) {
            clearTimeout(obj.timer)
            obj.timer = null
        }
        popups.filter(p => p !== obj).push(obj);
        return {popups}
    }),
    showSuccess: (text) => set((state) => {
        state.show(text, 'success')
        return {}
    }),
    showInfo: (text) => set((state) => {
        state.show(text, 'info')
        return {}
    }),
    showWarning: (text) => set((state) => {
        state.show(text, 'warning')
        return {}
    }),
    showError: (text) => set((state) => {
        state.show(text, 'error')
        return {}
    }),
}))

const Sub = ({children}) => <sub style={{position:'absolute', bottom:0, right:0, marginRight:5}}>{children}</sub>;

export default function Toast() {
    const popups = useToastStore(state => state.popups);
    const remove = useToastStore(state => state.remove);
    const freeze = useToastStore(state => state.freeze);
    return (
        <Stack sx={{width: '100%'}}>
            <Snackbar
                anchorOrigin={{vertical: 'top', horizontal: 'right' }}
                sx={{mt:'35px'}}
                open={!!popups.length}
            >
                <div>
                    {popups.map(p => (
                        <Alert
                            key={p.key}
                            severity={p.severity || 'error'}
                            variant="filled"
                            sx={{minWidth: '40vw', width: '100%', position: 'relative', mb:1}}
                            onDoubleClick={() => remove(p)}
                            onClick={() => freeze(p)}
                        >
                            {p.text}
                            {p.timer ? '' : <Sub>(double-click to clear)</Sub>}
                        </Alert>
                    ))}
                </div>
            </Snackbar>
        </Stack>
    )
}
